import { createSlice } from '@reduxjs/toolkit';

const dashboardSlice = createSlice({
  name: 'auth',
  initialState: {
    filtersReady: false,
    currencies: [],
    payinMethods: [],
    payoutMethods: [],
    trafficTypes: [],
    availability: [{
      label: 'Offline',
      value: 'Offline'
    }, {
      label: 'Online',
      value: 'Online'
    }]
  },
  reducers: {
    setFilters(state, action) {
      const { currencies, payinMethods, payoutMethods, trafficTypes } = action.payload;
      state.filtersReady = true;
      state.currencies = currencies;
      state.payinMethods = payinMethods;
      state.payoutMethods = payoutMethods;
      state.trafficTypes = trafficTypes;
    }
  }
});

export const { setFilters } = dashboardSlice.actions;
export default dashboardSlice.reducer;